import { render, staticRenderFns } from "./CascoAjanlatAdatokB11_V0.vue?vue&type=template&id=2b18c68d&"
import script from "./CascoAjanlatAdatokB11_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB11_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports